<template>
  <el-dialog
    v-if="dialogVisible"
    class="create-channel-dialog common-dialog"
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    :before-close="handleCancel"
    :title="title"
  >
    <el-form
      ref="dataForm"
      :model="dataForm"
      :label-position="position"
      :rules="editRule"
      :label-width="`${adaptationVars.formLabelWidth}px`"
    >
      <el-form-item label="扩容通道名称" prop="chanName">
        <el-input v-model="dataForm.chanName"></el-input>
      </el-form-item>

      <el-form-item label="余额" prop="balance">
        <el-input v-model="dataForm.balance"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" :disabled="disabled" @click="handleCreateOffChain()"
        >确定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import adaptation from '@/mixins/adaptation'
export default {
  name: 'CreateChannel',
  mixins: [adaptation],
  adaptationVarsDefine: {
    formLabelWidth: 120
  },
  data() {
    return {
      disabled: false,
      dialogVisible: false,
      orgOptions: [], //组织
      userOptions: [], //用户列表
      nodeList: [], //节点列表
      orgId: '',
      title: '新建扩容通道',
      position: 'right',
      dataForm: {
        chanName: '', //通道名称
        offChainId: '',
        chainId: '',
        balance: null
      },
      editRule: {
        chanName: [
          { required: true, message: '请输入', trigger: 'blur' },
          { pattern: /^[A-Za-z0-9]+$/, message: '只能输入英文和数字', trigger: 'blur' }
        ],
        balance: [
          { required: true, message: '请输入', trigger: 'blur' },
          { pattern: /^[1-9]\d*$/, message: '请输入正整数', trigger: 'blur' }
        ]
      },
      adaptationVars: {
        formLabelWidth: 120
      }
    }
  },
  mounted() {},
  methods: {
    //创建扩容节点
    handleCreateOffChain() {
      this.$refs.dataForm.validate(async valid => {
        if (valid) {
          this.disabled = true
          //获取form数据
          this.dataForm.chainId = this.$route.query.chainId
          this.dataForm.offChainId = JSON.parse(this.$route.query.detail).id
          this.dataForm.balance = Number(this.dataForm.balance)
          this.$apis.chain
            .createChannel(this.dataForm)
            .then(res => {
              if (res) {
                this.$message.success('创建扩容通道成功')
                this.handleCancel()
              }
            })
            .catch(err => {
              this.$message.error(errCode[err.response['data']['errors'][0]['code']])
              this.disabled = false
            })
        } else {
          this.$message.warning('请完善信息')
          this.disabled = false
          return
        }
      })
    },
    handleCancel() {
      this.dialogVisible = false
      this.disabled = false
      this.$emit('updateChan:list')
      this.$refs.dataForm.resetFields()
    },
    handleOpen(data) {
      this.dataForm = {
        chanName: '', //通道名称
        offChainId: '',
        chainId: '',
        balance: null
      }
      this.dialogVisible = true
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

@include theme('create-channel-dialog', (), ());
.create-channel-dialog.common-dialog {
  @include adaptation(());
  /deep/ .el-dialog {
    width: var(--common-dialog-medium-width);
  }

  .el-form {
    margin-right: var(--common-dialog-form-margin-right);
  }

  .el-select {
    width: 100%;
  }
}
</style>
